const liuyao = {
  'header.title': '六爻起卦',
  'header.back': '返回',
  'intro.title': '六爻起卦',
  'intro.subtitle': '心誠則靈 · 一事一卦',
  'intro.descTitle': '何為六爻起卦',
  'intro.badge': '新手必讀',
  'intro.desc': '六爻預測源於《周易》，通過三枚銅錢六次搖卦，得出一個六爻卦象。以日干五行為基準，結合六親、六神、世應關係，推演事情吉凶變化。',
  'intro.step1': '靜心凝神，默念所問之事',
  'intro.step2': '依次搖卦六次（從下往上）',
  'intro.step3': '查看卦象與詳細解析',
  'intro.startBtn': '開始起卦',
  'shake.title': '第 {{count}} 爻',
  'shake.subtitle': '請誠心搖卦',
  'shake.hint': '靜心凝神，默念問題，點擊下方按鈕搖卦',
  'shake.btn': '搖卦',
  'shake.animating': '搖卦中...',
  'coin.head': '正',
  'coin.tail': '反',
  'yao.yang': '陽爻',
  'yao.yin': '陰爻',
  'yao.moving': '動爻',
  'yao.still': '靜爻',
  'yao.oldYang': '老陽',
  'yao.oldYin': '老陰',
  'yao.youngYang': '少陽',
  'yao.youngYin': '少陰',
  'result.title': '卦象已成',
  'result.hexagram': '本卦',
  'result.changedHex': '變卦',
  'result.movingLines': '動爻',
  'result.noMoving': '無動爻',
  'result.shi': '世',
  'result.ying': '應',
  'result.viewDetail': '查看詳細解析',
  'result.reShake': '重新起卦',
  'result.copy': '複製卦象',
  'result.copied': '已複製',
  'result.exportPdf': '導出PDF',
  'result.exported': '已導出',
  'result.backToResult': '返回結果',
  'progress.prefix': '已完成',
  'progress.suffix': '爻',
  'share.mainHex': '本卦',
  'share.changedHex': '變卦',
  'share.movingCore': '動爻核心',
  'share.progress': '化進',
  'share.retreat': '化退',
  'share.support': '回頭生',
  'share.restrain': '回頭克',
  'share.otherRelation': '其他',
  'share.needResult': '請先完成搖卦後再分享',
};

export default liuyao;